import { Text, View } from '@react-pdf/renderer';

import { styles } from '@/components/Contract/Download/style';

const Nebraska = () => {
  return (
    <View style={styles.section}>
      <Text style={styles.title}>Nebraska Specific Terms</Text>

      <View style={styles.list}>
        <Text style={styles.listItem}>
          1. Disclosure required on or before the purchase contract is signed.
        </Text>

        <Text style={styles.listItem}>
          2. <Text style={styles.underline}>Lead-Based Paint Disclosure</Text> –
          Only for residences that were built before 1978. This information
          should be available at the County's Revenue Office.
        </Text>

        <Text style={styles.listItem}>
          3.{' '}
          <Text style={styles.underline}>
            Seller's Property Condition Disclosure Statement
          </Text>{' '}
          – Buyers must be given a written statement describing the property's
          condition before the purchase agreement becomes effective.
        </Text>
      </View>
    </View>
  );
};

export default Nebraska;
